import "@/App.css";
import "@/index.css";
import Deck from "@/components/deck/Deck";

function App() {
  return <Deck />;
}

export default App;
